import { useAppContext } from '../contexts/AppContext'
import { BackendClient } from '@playbooks/core/src/services/BackendClient'

/**
 * Custom hook to create an instance of BackendClient with the necessary configuration.
 * @returns An instance of BackendClient
 */
export function usePlaybooksBackendClient() {
  const { config } = useAppContext()

  if (!config?.playbooksBackendUrl || !config?.serviceBaseUrl) {
    console.warn(
      'Playbooks Backend configuration is missing. Please ensure playbooksBackendUrl, serviceBaseUrl, and serviceAuthToken are provided in the ActionCardsConfig.',
    )
  }

  const { playbooksBackendUrl, playbooksBackendTokenEndpoint, serviceBaseUrl, serviceAuthToken } = config

  // The external environment where the AC is built in can provide a specific token endpoint
  // which can handle auth specific to that env (e.g. cookie-based auth within composer-next app).
  // If a specific token endpoint is not provided, use the one built into the meeting-service,
  // it can handle auth based on Person ID tokens and and Identity-issued OAuth tokens (#13865)
  const tokenIssuerEndpoint =
    playbooksBackendTokenEndpoint || (serviceBaseUrl ? `${serviceBaseUrl}/playbooks-token` : undefined)

  return new BackendClient({
    backendUrl: playbooksBackendUrl || undefined,
    tokenIssuerEndpoint: tokenIssuerEndpoint || undefined,
    tokenIssuerApiToken: serviceAuthToken || undefined,
  })
}
